import React from 'react';
import BasicInformation from './beneficiary-setup/basic-information';
import BeneficiaryLocation from './beneficiary-setup/beneficiary-location';

const BeneficiarySetup = () => {
  return (
    <div className='grid gap-8'>
    <BasicInformation />
    <BeneficiaryLocation />
   </div>
  );
};

export default BeneficiarySetup;
